// extracted by mini-css-extract-plugin
module.exports = {"uploadBtn":"ImgUpload_uploadBtn__1qJ9d","thumbnail":"ImgUpload_thumbnail__1jnry","removeIcon":"ImgUpload_removeIcon__3aNgt"};